var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('span',{staticClass:"text-wrapper",domProps:{"innerHTML":_vm._s(_vm.htmlTmp)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }